import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .filters-tag-list {
    background: ${colors.grayExtraLight};
    display: flex;
    flex-direction: row;
    list-style: none;
    overflow-y: auto;
    margin: 0;
    padding: 13px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/FilterTags/list/styles.js